import { ObjectUtils } from "~app/common/utils/object-utils";
import { ValidationContext } from "~app/common/validation/validationContext";
import { ValidationErrorLevels } from "~app/common/validation/ValidationErrorLevels";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";

export class ArbetsorderHandelssortimentDetailsValidation {

    static init(model: { avstandNarmasteIndustriJusterat?: number }): ValidationContext {
        // eslint-disable-next-line sonarjs/concise-regex
        const isNumberGreaterThan0AndOnlyOneDecimal = (newValue: number): boolean => !/^[0-9]+(\.[0-9]{1})?$/.test(newValue.toString()) || newValue <= 0;

        const context = new ValidationContext();
        context.errorLevel = ValidationErrorLevels.error;
        context.create(ValidationScopes.spara).withRules([
            {
                applicable: (newValue) => !ObjectUtils.isNullOrUndefined(newValue),
                errorLevel: ValidationErrorLevels.error,
                expression: (newValue) => !isNumberGreaterThan0AndOnlyOneDecimal(newValue),
                message: { text: "Värdet måste vara numeriskt och större än 0. Endast en decimal tillåten." },
                model: () => model.avstandNarmasteIndustriJusterat,
                name: "avstandNarmasteIndustriJusterat"
            }
        ]);

        return context;
    }
}
